// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__31H7o","empty":"ModalGraph_empty__2DXu2"};